export type BlockKind = 'table' | 'chart' | 'shipment_card' | 'share_link' | 'export' | string;

export interface TableBlock {
  kind: 'table';
  title?: string;
  columns: string[];
  rows: (string | number | boolean | null | undefined)[][];
  total_count: number;
}

export interface ChartSeries {
  name: string;
  data: number[];
}

export interface ChartBlock {
  kind: 'chart';
  chart: 'line' | 'bar';
  title?: string;
  x: string[];
  series: ChartSeries[];
}

export interface ShipmentCardHoldInfo {
  hold_date?: string | null;
  hold_reason?: string | null;
  hold_branch?: string | null;
}

export interface ShipmentCardBlock {
  kind: 'shipment_card';
  cn_number: string;
  origin: string;
  destination: string;
  status?: string;
  shipment_status?: string;
  cn_date?: string | null;
  origin_pincode?: string | number | null;
  destination_pincode?: string | number | null;
  distance_km?: number | null;
  edd?: string | null;
  delivery_date?: string | null;
  pod_upload_date?: string | null;
  actual_weight?: number | null;
  charge_weight?: number | null;
  load_type?: string | null;
  consignor?: string | null;
  consignee?: string | null;
  pod_link?: string | null;
  hold_info?: ShipmentCardHoldInfo | string | null;
  invoice_numbers?: string[] | null;
  ewaybill_numbers?: string[] | null;
  remaining_km?: number | null;
  [key: string]: any;
}

export interface ShareLinkBlock {
  kind: 'share_link';
  cn_number: string;
  url: string;
}

export interface ExportBlock {
  kind: 'export';
  label: string;
  url: string;
}

export type Block =
  | TableBlock
  | ChartBlock
  | ShipmentCardBlock
  | ShareLinkBlock
  | ExportBlock
  | { kind: string; [key: string]: any };

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  blocks?: Block[];
  created_at?: string;
}

export interface Conversation {
  conversation_id: string;
  title?: string | null;
  created_at: string;
  updated_at: string;
  message_count: number;
}

export const TOOL_STATUS_LABELS: Record<string, string> = {
  find_shipments: 'Searching shipments…',
  get_shipment: 'Looking up shipment…',
  track_shipment: 'Tracking shipment…',
  query_shipments: 'Counting shipments…',
  create_share_link: 'Creating share link…',
  export_shipments: 'Preparing export…',
};

export const STATUS_LABELS: Record<string, string> = {
  in_transit: 'In Transit',
  delivered: 'Delivered',
  local: 'Local',
};

export const SHIPMENT_STATUS_LABELS: Record<string, string> = {
  on_schedule: 'On Schedule',
  on_hold: 'On Hold',
  awaiting_pickup: 'Awaiting Pickup',
  awaiting_unloading: 'Awaiting Unloading',
  incident_reported: 'Incident Reported',
};

export function getStatusLabel(status?: string | null): string {
  if (!status) return '';
  return STATUS_LABELS[status] || status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export function getShipmentStatusLabel(status?: string | null): string {
  if (!status) return '';
  return SHIPMENT_STATUS_LABELS[status] || status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

export {
  getOrdinalSuffix,
  formatChartDate,
  parseUtcDate,
  formatUtcToLocal,
  formatUtcToLocalDateOnly,
} from '../../lib/utils';

